import SiteChrome from "@chrome/SiteChrome";
import { HtmlPageTitle } from "@components/HtmlPageTitle";
import { MetaDescription } from "@components/MetaDescription";
import DevCertificationPage from "@components/developer-certification/DevCertificationPage";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";

const DevCertificationLandingPage = () => (
  <SiteChrome noPadding>
    <HtmlPageTitle title={`Blues Developer Certification Program - ${SiteHtmlPageTitle}`} />
    <MetaDescription description="Test your knowledge of Blues and wireless connectivity to earn your Blues Developer Certification." />
    <DevCertificationPage />
  </SiteChrome>
);

export default DevCertificationLandingPage;
